module.exports = __webpack_public_path__ + "img/5.b242574b.jpg";